module.exports = __webpack_public_path__ + "static/media/rose-t.722fa549.svg";